import { useCallback, useEffect, useRef, useState } from "react";
import api from "utils/apiService";

export default function useAdminStats(endpoint, params = {}, options = {}) {
  const { enabled = true, deps = [] } = options;
  const [state, setState] = useState({
    data: null,
    error: null,
    loading: enabled,
  });
  const requestId = useRef(0);

  const refetch = useCallback(async () => {
    if (!enabled || !endpoint) return;
    const id = ++requestId.current;
    setState((s) => ({ ...s, loading: true }));
    const res = await api.get(endpoint, params);
    if (id !== requestId.current) return;
    if (res?.error) {
      setState({ data: null, error: res.error, loading: false });
    } else {
      setState({ data: res, error: null, loading: false });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [endpoint, JSON.stringify(params), enabled]);

  useEffect(() => {
    refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refetch, ...deps]);

  return { ...state, refetch };
}
